"use client";

import React from "react";
import { useLocalizedText } from "@/content/i18n/context";

export interface ServiceBenefitItemProps {
  title: string;
  description: string;
  icon?: string;
  iconColor?: string;
  iconBgColor?: string;
  className?: string;
}

export default function ServiceBenefitItem({
  title,
  description,
  icon = "fas fa-check",
  className = ""
}: ServiceBenefitItemProps) {
  const translatedTitle = useLocalizedText(title);
  const translatedDescription = useLocalizedText(description);

  return (
    <div
      className={`flex items-start rounded-2xl border border-border bg-card p-4 ${className}`}
    >
      <div className="mt-1 flex-shrink-0">
        <div className="flex h-8 w-8 items-center justify-center rounded-xl bg-primary/10">
          <i className={`${icon} text-sm text-primary`} aria-hidden></i>
        </div>
      </div>
      <div className="ml-4">
        <h4 className="mb-1 text-lg font-semibold text-neutral-emphasis">
          {translatedTitle}
        </h4>
        <p className="text-neutral-muted">{translatedDescription}</p>
      </div>
    </div>
  );
}
